<div><form-element :options="optionsWert" v-model="model.argument.wert" :errors="errors.wert" :disabled="disabled"></form-element></div>